import { FunctionComponent, useCallback, useState } from 'react'
import { Action, Container, Document, Header } from './styles'
import InputFile from 'shared/components/InputFile'
import { steps } from 'modules/onboarding'
import { Button, Heading, Paragraph } from '@tmov/design-system'
import { validateTypeFile } from 'shared/utils/validates'
import { colors } from 'shared/styles/colors'
import { useOnboardContext } from 'modules/onboarding/context'

type TProps = {
  setSelectedStep?(step: number): void
}

const UploadDoc: FunctionComponent<TProps> = ({ setSelectedStep }) => {
  const { state, dispatch } = useOnboardContext()

  const [photoOk, setPhotoOk] = useState(false)
  const [file, setFile] = useState('')
  const [isWrongExtension, setIsWrongExtension] = useState(false)

  const handleSelectFile = useCallback((base64: string, fileName: string) => {
    setFile(fileName)
    if (validateTypeFile(fileName)) {
      setIsWrongExtension(false)
      setPhotoOk(true)
      dispatch({
        ...state,
        doc_imagem_frente: base64,
        doc_imagem_verso: base64,
      })
    } else {
      setIsWrongExtension(true)
      setPhotoOk(false)
    }
  }, [])

  return (
    <Container>
      <Header />
      <Document>
        <Heading variant="h3">Documento</Heading>
        <Paragraph variant="p1">
          Para validar essa etapa é necessário o envio de um documento com
          número de CPF.
        </Paragraph>
        <div>
          <InputFile
            id="photo-singup"
            onSelectFile={handleSelectFile}
            file={file}
            isWrongExtension={isWrongExtension}
            colorFileText="black"
            color={colors.green}
          />
        </div>
      </Document>

      <Action>
        <Button
          type="button"
          variant="contained"
          size="lg"
          onClick={() => setSelectedStep(steps.SelecionaDoc)}
        >
          Voltar
        </Button>
        <Button
          disabled={!photoOk}
          onClick={() => {
            setSelectedStep(steps.Pin)
          }}
        >
          Próximo
        </Button>
      </Action>
    </Container>
  )
}

export default UploadDoc
